import { render, staticRenderFns } from "./IndexListTrain.vue?vue&type=template&id=50d328b2&scoped=true&"
import script from "./IndexListTrain.vue?vue&type=script&lang=js&"
export * from "./IndexListTrain.vue?vue&type=script&lang=js&"
import style0 from "./IndexListTrain.vue?vue&type=style&index=0&id=50d328b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d328b2",
  null
  
)

export default component.exports